import { History } from 'history'

export class UnsavedChangesHandler {
    private unblock: (() => void) | null = null
    private pendingPath: string | null = null
    private onShowDialog: (() => void) | null = null
    private cleanupBeforeUnload: (() => void) | null = null

    setup(history: History, hasUnsavedChanges: boolean, onShowDialog: () => void) {
        this.onShowDialog = onShowDialog

        this.cleanup()

        if (!hasUnsavedChanges) {
            return
        }

        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            e.preventDefault()
            e.returnValue = ''
            return ''
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        this.cleanupBeforeUnload = () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }

        this.unblock = history.block((location) => {
            this.pendingPath = location.pathname + (location.search || '')
            if (this.onShowDialog) {
                this.onShowDialog()
            }
            return false
        })
    }

    cleanup() {
        if (this.unblock) {
            this.unblock()
            this.unblock = null
        }
        if (this.cleanupBeforeUnload) {
            this.cleanupBeforeUnload()
            this.cleanupBeforeUnload = null
        }
        this.pendingPath = null
    }

    confirm(history: History) {
        const path = this.pendingPath
        this.cleanup()
        if (path) {
            history.push(path)
        }
    }

    cancel() {
        this.pendingPath = null
    }

    getPendingPath(): string | null {
        return this.pendingPath
    }
}

export function getHistory(): History | null {
    return null
}

